module.exports = __webpack_public_path__ + "images/sam/menu-button-arrow-disabled.png";